import React, { useEffect, useState } from 'react'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Carousel from 'srcReact/components/common2/Carousel'
import MediaImage from 'srcReact/components/common2/MediaImage'
import DocumentPreview from 'srcReact/MessengerPage/components/DocumentPreview'
import CarouselImage from '../CarouselImage'
import SingleImage from '../SingleImage'
import styles from './styles.module.scss'
import { convertByteToMB, openMedia } from 'srcReact/helpers/fileHelper'
import { validatePDFMIMEType, getDescryptedMedia, getNativeDecryptedMedia } from 'srcReact/helpers/utils'

function Media({
  files,
  feed,
  feedId,
  isComment,
  isMobile,
  isTablet,
  isNative,
  isFilesOwner,
  showImageModal,
  parentElementId,
  feedInFileModal,
  level
}) {
  const [images, setImages] = useState([])
  const [documents, setDocuments] = useState([])
  useEffect(() => {
    if (files && files.length > 0) {
      const imgs = []
      const docs = []
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let fileName = file ? file.name || file.path : ''
        const extension = fileName ? fileName.split('.').pop() : ''
        if (appConstantSettings.ACCEPTED_IMAGE_TYPES.includes(extension.toLowerCase())) {
          imgs.push(file)
        } else {
          docs.push(file)
        }
      }
      setImages(imgs)
      setDocuments(docs)
    }
  }, [files])

  const openFile = (doc, index, documents, isFilesOwner, feedId, feed, level) => {
    const fileSizeInMB = convertByteToMB(doc?.original_file_size)
    const isFileSizeExceed = fileSizeInMB > appConstantSettings.FILE_SIZE_LIMIT_FOR_PREVIEW
    const isValidPdf = validatePDFMIMEType(doc)
    const isEncrypted = doc.is_original === 0
    const shouldImageModalOpen = !isValidPdf || (isValidPdf && isFileSizeExceed && isEncrypted)
    if (showImageModal && shouldImageModalOpen) {
      showImageModal(doc, index, documents, isFilesOwner, feedId, feed, level)
    }
    //if file is a pdf and file size is greater than mention limit, do not open the preview
    if (isValidPdf && (!isFileSizeExceed || doc.is_original)) {
      const { url, is_original, original_tag, mime_type } = doc
      getDescryptedMedia(url, is_original, original_tag, mime_type, doc.id).then((data) => {
        // native decryption
        if (isNative) {
          getNativeDecryptedMedia(url, data.img, is_original, original_tag, mime_type, doc.name, 'open')
          return
        }
        openMedia(is_original, data.img, doc.name)
      })
    }
  }

  return (
    <div className={`${styles.fileContainer} ${files.length === 0 && styles.fileContainerNoPadding}`}>
      {images && images.length > 0 ? (
        isComment ? (
          <Carousel
            showArrows={!isMobile && !isNative && images.length > 1}
            className={styles.carousel}
            pagination={
              isMobile || isNative || feedInFileModal
                ? images.length > 1
                : isTablet
                ? images.length > 2
                : images.length > 3
            }
            enableSwipe={true}
            verticalMode={false}
            itemPadding={[0, 0]}
            breakPoints={[
              { itemsToShow: isMobile || isNative || feedInFileModal ? 1 : isTablet ? 2 : 3 },
              { itemsToScroll: 1 }
            ]}>
            {images.map((img, index) => (
              <MediaImage
                file={img}
                files={files}
                feed={feed}
                showImageModal={showImageModal}
                index={index}
                isFilesOwner={isFilesOwner}
                entityId={feedId}
                size='large'
                parentElementId={parentElementId}
                feedLevel={level}
              />
            ))}
          </Carousel>
        ) : images.length === 1 ? (
          <SingleImage
            file={images[0]}
            index={0}
            key={0}
            files={images}
            isFilesOwner={isFilesOwner}
            showImageModal={showImageModal}
            feedId={feedId}
            feed={feed}
            parentElementId={parentElementId}
            feedLevel={level}
          />
        ) : (
          <Carousel
            showArrows={!isMobile && !isNative}
            className={styles.carousel}
            pagination={true}
            enableSwipe={true}
            verticalMode={false}
            itemPadding={[0, 0]}
            breakPoints={[{ itemsToShow: 1 }, { itemsToScroll: 1 }]}>
            {images.map((img, index) => (
              <CarouselImage
                file={img}
                files={images}
                index={index}
                key={index}
                isFilesOwner={isFilesOwner}
                feedId={feedId}
                feed={feed}
                showImageModal={showImageModal}
                parentElementId={parentElementId}
                feedLevel={level}
              />
            ))}
          </Carousel>
        )
      ) : null}
      {documents && documents.length > 0 && (
        <Carousel
          showArrows={!isMobile && !isNative && documents.length > 1}
          className={`${styles.carousel} ${images.length > 0 && styles.marginTop} ${
            documents.length === 1 && styles.CarouselSingleItem
          }`}
          pagination={
            isMobile || isNative || feedInFileModal
              ? documents.length > 1
              : isTablet
              ? documents.length > 2
              : documents.length > 3
          }
          enableSwipe={true}
          verticalMode={false}
          itemPadding={[0, 0]}
          breakPoints={[
            { itemsToShow: isMobile || isNative || feedInFileModal ? 1 : isTablet ? 2 : 3 },
            { itemsToScroll: 1 }
          ]}>
          {documents.map((doc, index) => (
            <button
              type='button'
              aria-label={doc.name}
              key={doc.id}
              className={styles.docButton}
              onClick={() => openFile(doc, index, documents, isFilesOwner, feedId, feed, level)}>
              <DocumentPreview
                className={styles.doc}
                key={doc.id}
                fileName={doc ? doc.name || doc.path : ''}
                extension={doc.name ? doc.name.split('.').pop() : ''}
                showOptions={false}
                mimeType={doc.mime_type}
                isOriginal={doc.is_original}
                originalTag={doc.original_tag}
                documentId={doc.id}
              />
            </button>
          ))}
        </Carousel>
      )}
    </div>
  )
}

export default Media
